"use client";
import { useParams } from 'react-router-dom'; // Use react-router-dom for routing.
import React, { useEffect, useState } from "react"; 
// import { stripHtml } from '../../utils/helpers';

// import ServiceBg from '../../assets/images/backgrounds/service-details-get-touch-bg.jpg'

export default function Home() {
   const { slug, stateslug } = useParams();
   const [setPosts] = useState([]);
   
   const [isActive, setIsActive] = useState({ status: false, key: 1 });
   const [setCategories] = useState([]);

  const handleToggle = (key) => {
   
    setIsActive({
      status: isActive.key === key ? false : true,
      key: isActive.key === key ? null : key,
    });
  };
    useEffect(() => {
      if (!slug) return;

      const topLevelSlug = slug;
      const postSlug = (stateslug && stateslug !== "null") ? stateslug : slug;
      
      fetch(`https://rsvpevents.local/wp-json/wp/v2/categories?slug=${topLevelSlug}`)
        .then((res) => res.json())
        .then((data) => {
          const parentCategory = data[0];
          if (parentCategory) {
          
            fetch(`https://rsvpevents.local/wp-json/wp/v2/categories?parent=${parentCategory.id}`)
              .then((res) => res.json())
              .then((subcats) => {
                setCategories(subcats);
              });
          } else {
            console.warn('No matching category found for slug:', topLevelSlug);
          }
        })
        .catch((err) => console.error('Error fetching categories:', err));

      
      fetch(`https://rsvpevents.local/wp-json/wp/v2/categories?slug=${postSlug}`)
        .then((res) => res.json())
        .then((categoryData) => {
          const category = categoryData[0];
          if (category) {
            fetch(`https://rsvpevents.local/wp-json/wp/v2/posts?categories=${category.id}`)
              .then((res) => res.json())
              .then((postsData) => {
                setPosts(postsData);
              });
          } else {
            console.warn(`No posts category found for slug: ${postSlug}`);
            setPosts([]);
          }
        })
        .catch((err) => console.error('Error fetching posts:', err));
    }, [slug, stateslug]);
  return (


        <div>
          {/* Service Details Start */}
          <section className="service-details">
            <div className="container">
              <div className="service-details__top">
                <div className="row">
                  
                  <div className="col-xl-12 col-lg-12">
                  <div className="container">
                    {/* <div className="locate-event__inner">
                <h3 className="locate-event__title">Search Events</h3>
               
                <form className="contact-form-validated locate-event__form">
                  <div className="row">
                  
                    <div className="col-xl-3 col-lg-3">
                      <div className="locate-event__input-box">
                        <div className="select-box">
                          <select className="selectmenu wide" defaultValue="Choose Option" >
                            <option value="">Choose Month</option>
                            <option value="January">January</option>
                            <option value="February">February</option>
                            <option value="March">March</option>
                            <option value="April">April</option>
                            <option value="May">May</option>
                            <option value="June">June</option>
                            <option value="July">July</option>
                            <option value="August">August</option>
                            <option value="September">September</option>
                            <option value="October">October</option>
                            <option value="November">November</option>
                            <option value="December">December</option>
                          </select>
                        </div>
                      </div>
                      
                    </div>

                  <div className="col-xl-12 col-lg-12">
                    <div className="locate-event__btn-box">
                    <button type="button" className="thm-btn locate-event__btn" >Clear All Filters</button>
                    </div>
                  </div>
                  </div>
                </form>
                <div className="result"></div>
              </div> */}
                <div className="schedule-one__inner">
                 
                    <div className="schedule-two__main-tab-box tabs-box">
                        
                        <div className="tabs-content">
                            
                               <div className="schedule-two__tab-content-box">
                                 
                                    
                                      <div className="schedule-two__sinlge" key=''>
                                        <div className="row">
                                          <div className="col-xl-12 col-lg-12">
                                            <div className="schedule-two__right">
                                              <div className="schedule-two__right-content">
                                                <h4 className="schedule-two__title">
                                                   Title
                                                </h4>
                                                <p className="schedule-two__text" >
                                                   Test desctiption
                                                </p>
                                                 <div className="schedule-two__btn-container" >
                                                   
                                                    
                                                    <a href='' target="_blank" className="schedule-two__btn">
                                                      Buy Ticket <span className="icon-arrow-right"></span>
                                                    </a>
                                                  </div>
                                              </div>
                                              <ul className="list-unstyled schedule-two__address">
                                                <li>
                                                  <div className="icon">
                                                    <span className="icon-pin"></span>
                                                  </div>
                                                  <div className="text">
                                                    <p className='schedule-two__event'> Venue </p>
                                                  </div>
                                                </li>
                                                <li>
                                                  <div className="icon">
                                                    <span className="icon-clock"></span>
                                                  </div>
                                                  <div className="text">
                                                    <p className='schedule-two__date'>
                                                      Long Date
                                                    </p>
                                                  </div>
                                                </li>
                                                
                                                <li>
                                                  <div className="icon">
                                                    <span className="icon-user"></span>
                                                  </div>
                                                  <div className="text">
                                                   
                                                      <p className="schedule-two__promo">
                                                        Promo Code <br />
                                                        Promo Code
                                                      </p>
                                                  
                                                  </div>
                                                </li>
                                                  
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                  
                                </div>

                          
                        </div>
                    </div>
                </div>
            </div>
                    </div>
                
                </div>
              </div>
             
            </div>
          </section>
        </div>

  );
}
